export default "__VITE_ASSET__bhs27eVx__"